import React, { useState, useEffect } from 'react'
import '../../App.css';

import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Typography, Paper, useMediaQuery, useTheme, Box, Card, CardContent } from '@mui/material';


function RaspSpec() {
    const [rasp, setRasp] = useState([]);

    function getNextDays(
        count = 7,
        timeZone = 'Asia/Kamchatka',
        startDate = new Date()
        ) {
        const result = [];

        const weekdayFormatter = new Intl.DateTimeFormat('ru-RU', {
            weekday: 'long',
            timeZone,
        });

        const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone,
        });

        for (let i = 0; i < count; i++) {
            const d = new Date(startDate);
            d.setDate(d.getDate() + i);

            result.push({
            date: dateFormatter.format(d),     // "20.11.2025" в зоне Asia/Kamchatka
            weekday: weekdayFormatter.format(d), // "четверг" в зоне Asia/Kamchatka
            });
        }

        return result;
        }


    const days = getNextDays();    
    const colLabels = ["№ каб", "Врач"].concat(days.map(item => item.date + "\n" + item.weekday))
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        fetch('/api/raspisanie3.wget')
          .then(res => res.text())
          .then(text => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text.replaceAll('<span class="dol">',"\n").replaceAll("<sup>",":"), 'text/html');
    
            // пример: берём все строки таблицы
            const trs = Array.from(doc.querySelectorAll('table tr'));
    
            const data = trs.map(tr => {
              const tds = Array.from(tr.querySelectorAll('td'));
              return tds.map(td => td.textContent.trim());
            });
            setRasp(data.filter(item => item.length > 0));
          })
          .catch(err => console.error('Ошибка загрузки файла:', err));
      }, []);


      if (isMobile) {
            // мобильный вид — карточки
            return (
            <div className="App"> 
                <Box display="flex" flexDirection="column" gap={1}>
                    {rasp.map((row, keyRow) => (
                    <Card key={keyRow} variant="outlined">
                        <CardContent>
                            {row.map((cell, keyCell) => 
                            <Table>
                                <TableBody>
                                    <TableRow key = {keyRow}>
                                        <TableCell width={"100px"} key={keyRow + keyCell}>
                                            {colLabels[keyCell]}
                                        </TableCell>
                                        <TableCell key={keyRow + keyCell + "1"}>
                                            {keyCell < 2 ? cell : cell.replaceAll(" ","\n")}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            )}
                        </CardContent>
                    </Card>
                    ))}
                </Box>
            </div>
            );
        }


      return (
        <div className="App"> 
            <TableContainer component={Paper}>
                <Table aria-label="table">
                    <TableHead>
                    <TableRow>
                        {colLabels.length && colLabels?.map((item) => 
                            <TableCell align="right" key={item}>
                                <Typography fontWeight={"bold"}>{item}</Typography> 
                            </TableCell>)}
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {rasp && rasp?.map((row, keyRow) => 
                  
                                <TableRow key = {keyRow}>
                                    {row.map((cell, keyCell) => <TableCell key={keyRow + keyCell}> {keyCell < 2 ? cell : cell.replaceAll(" "," \n")} </TableCell>)}   
                                </TableRow>
                            
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
      );


}

export default RaspSpec;